/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetTreatmentsParams,
  HTTPValidationError,
  TreatmentCreate,
  TreatmentRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new treatment.
 * @summary Create Treatment
 */
export const createTreatment = (
  treatmentCreate: TreatmentCreate,
  signal?: AbortSignal,
) => {
  return customInstance<TreatmentRead>({
    url: `/api/treatment/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: treatmentCreate,
    signal,
  });
};

export const getCreateTreatmentMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTreatment>>,
    TError,
    { data: TreatmentCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTreatment>>,
  TError,
  { data: TreatmentCreate },
  TContext
> => {
  const mutationKey = ["createTreatment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTreatment>>,
    { data: TreatmentCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createTreatment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTreatmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTreatment>>
>;
export type CreateTreatmentMutationBody = TreatmentCreate;
export type CreateTreatmentMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Treatment
 */
export const useCreateTreatment = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTreatment>>,
      TError,
      { data: TreatmentCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTreatment>>,
  TError,
  { data: TreatmentCreate },
  TContext
> => {
  const mutationOptions = getCreateTreatmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many treatments.

Results are paginated.
 * @summary Get Treatments
 */
export const getTreatments = (
  params?: GetTreatmentsParams,
  signal?: AbortSignal,
) => {
  return customInstance<TreatmentRead[]>({
    url: `/api/treatment/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetTreatmentsQueryKey = (params?: GetTreatmentsParams) => {
  return ["api", "treatment", ...(params ? [params] : [])] as const;
};

export const getGetTreatmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetTreatmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatments>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTreatmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTreatments>>> = ({
    signal,
  }) => getTreatments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTreatments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTreatmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTreatments>>
>;
export type GetTreatmentsQueryError = ErrorType<void | HTTPValidationError>;

export function useGetTreatments<
  TData = Awaited<ReturnType<typeof getTreatments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetTreatmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTreatments>>,
          TError,
          Awaited<ReturnType<typeof getTreatments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTreatments<
  TData = Awaited<ReturnType<typeof getTreatments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetTreatmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTreatments>>,
          TError,
          Awaited<ReturnType<typeof getTreatments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTreatments<
  TData = Awaited<ReturnType<typeof getTreatments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetTreatmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Treatments
 */

export function useGetTreatments<
  TData = Awaited<ReturnType<typeof getTreatments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetTreatmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTreatmentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to check for duplicate treatments.
 * @summary Check Create Treatment
 */
export const checkCreateTreatment = (
  treatmentCreate: TreatmentCreate,
  signal?: AbortSignal,
) => {
  return customInstance<TreatmentRead[]>({
    url: `/api/treatment/check-create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: treatmentCreate,
    signal,
  });
};

export const getCheckCreateTreatmentMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkCreateTreatment>>,
    TError,
    { data: TreatmentCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkCreateTreatment>>,
  TError,
  { data: TreatmentCreate },
  TContext
> => {
  const mutationKey = ["checkCreateTreatment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkCreateTreatment>>,
    { data: TreatmentCreate }
  > = (props) => {
    const { data } = props ?? {};

    return checkCreateTreatment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckCreateTreatmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkCreateTreatment>>
>;
export type CheckCreateTreatmentMutationBody = TreatmentCreate;
export type CheckCreateTreatmentMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Check Create Treatment
 */
export const useCheckCreateTreatment = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkCreateTreatment>>,
      TError,
      { data: TreatmentCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkCreateTreatment>>,
  TError,
  { data: TreatmentCreate },
  TContext
> => {
  const mutationOptions = getCheckCreateTreatmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get a treatment by ID.
 * @summary Get Treatment
 */
export const getTreatment = (treatmentId: number, signal?: AbortSignal) => {
  return customInstance<TreatmentRead>({
    url: `/api/treatment/${treatmentId}`,
    method: "GET",
    signal,
  });
};

export const getGetTreatmentQueryKey = (treatmentId?: number) => {
  return ["api", "treatment", treatmentId] as const;
};

export const getGetTreatmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatment>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  treatmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatment>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTreatmentQueryKey(treatmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTreatment>>> = ({
    signal,
  }) => getTreatment(treatmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!treatmentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTreatment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTreatmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTreatment>>
>;
export type GetTreatmentQueryError = ErrorType<void | HTTPValidationError>;

export function useGetTreatment<
  TData = Awaited<ReturnType<typeof getTreatment>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  treatmentId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTreatment>>,
          TError,
          Awaited<ReturnType<typeof getTreatment>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTreatment<
  TData = Awaited<ReturnType<typeof getTreatment>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  treatmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTreatment>>,
          TError,
          Awaited<ReturnType<typeof getTreatment>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTreatment<
  TData = Awaited<ReturnType<typeof getTreatment>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  treatmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatment>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Treatment
 */

export function useGetTreatment<
  TData = Awaited<ReturnType<typeof getTreatment>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  treatmentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTreatment>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTreatmentQueryOptions(treatmentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update a treatment by ID.
 * @summary Update Treatment
 */
export const updateTreatment = (
  treatmentId: number,
  treatmentCreate: TreatmentCreate,
) => {
  return customInstance<TreatmentRead>({
    url: `/api/treatment/${treatmentId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: treatmentCreate,
  });
};

export const getUpdateTreatmentMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTreatment>>,
    TError,
    { treatmentId: number; data: TreatmentCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTreatment>>,
  TError,
  { treatmentId: number; data: TreatmentCreate },
  TContext
> => {
  const mutationKey = ["updateTreatment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTreatment>>,
    { treatmentId: number; data: TreatmentCreate }
  > = (props) => {
    const { treatmentId, data } = props ?? {};

    return updateTreatment(treatmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTreatmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTreatment>>
>;
export type UpdateTreatmentMutationBody = TreatmentCreate;
export type UpdateTreatmentMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Treatment
 */
export const useUpdateTreatment = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTreatment>>,
      TError,
      { treatmentId: number; data: TreatmentCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTreatment>>,
  TError,
  { treatmentId: number; data: TreatmentCreate },
  TContext
> => {
  const mutationOptions = getUpdateTreatmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete a treatment by ID.
 * @summary Delete Treatment
 */
export const deleteTreatment = (treatmentId: number) => {
  return customInstance<unknown>({
    url: `/api/treatment/${treatmentId}`,
    method: "DELETE",
  });
};

export const getDeleteTreatmentMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTreatment>>,
    TError,
    { treatmentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTreatment>>,
  TError,
  { treatmentId: number },
  TContext
> => {
  const mutationKey = ["deleteTreatment"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTreatment>>,
    { treatmentId: number }
  > = (props) => {
    const { treatmentId } = props ?? {};

    return deleteTreatment(treatmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTreatmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTreatment>>
>;

export type DeleteTreatmentMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Treatment
 */
export const useDeleteTreatment = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTreatment>>,
      TError,
      { treatmentId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTreatment>>,
  TError,
  { treatmentId: number },
  TContext
> => {
  const mutationOptions = getDeleteTreatmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
